<script lang="ts">
  import type { ReportSectionId, ReportSectionKind } from "$core/report/report.types";
  import { getTalkTrackForSection } from "./talkTrack";

  export let section: ReportSectionId;

  /**
   * Mapeamento de ReportSectionId para ReportSectionKind (T27).
   * Permite que o componente continue aceitando o tipo legado enquanto
   * delega a logica de notas para o modulo talkTrack.ts.
   */
  const SECTION_ID_TO_KIND: Partial<Record<ReportSectionId, ReportSectionKind>> = {
    cover: "cover",
    "executive-summary": "executive-summary",
    "data-base": "base",
    visibility: "metrics",
    cost: "metrics",
    absence: "metrics",
    rework: "metrics",
    risk: "metrics",
    score: "score",
    recommendations: "recommendations",
    limitations: "limitations",
    assumptions: "assumptions",
    "next-steps": "next-steps",
  };

  $: sectionKind = SECTION_ID_TO_KIND[section] ?? null;
  $: notes = sectionKind ? getTalkTrackForSection(sectionKind) : [];
  /** Exibe apenas a primeira nota para manter layout consistente com a versao anterior. */
  $: note = notes[0]?.text ?? "";
</script>

{#if note}
  <aside class="talk-track" aria-label="Notas do consultor (interno)">
    <div class="talk-track__header">
      <span class="talk-track__icon" aria-hidden="true">🎙</span>
      <span class="talk-track__title">Notas do consultor</span>
    </div>
    <p class="talk-track__text">{note}</p>
  </aside>
{/if}

<style>
  .talk-track {
    background: var(--ptt-yellow-10, #fffbea);
    border: 1px solid var(--ptt-yellow-100);
    border-radius: var(--ptt-radius-md);
    padding: var(--ptt-space-4);
    display: flex;
    flex-direction: column;
    gap: var(--ptt-space-2);
  }

  .talk-track__header {
    display: flex;
    align-items: center;
    gap: var(--ptt-space-2);
  }

  .talk-track__icon {
    font-size: 1rem;
    line-height: 1;
  }

  .talk-track__title {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--ptt-gray-200, #555);
  }

  .talk-track__text {
    margin: 0;
    font-size: 0.9375rem;
    line-height: 1.6;
    color: var(--ptt-gray-300);
  }
</style>
